export default {
	apps: {
		add_new: "Add New",
		info: "Info",
		domain: "Domain",
		versions: "Versions",
		openEditor: "Open Editor",
		newApp: "New App",
		thisAppIsAweSomeOrDifferent: "This app is gonna be awesome or different description here!"
	}
}
